import { useEffect, useState } from 'react';
import { NewsItem } from '../../../types/news';

export default function Hero() {
  const [latestNews, setLatestNews] = useState<NewsItem | null>(null);

  useEffect(() => {
    // localStorage에서 뉴스 데이터 가져오기
    const savedNews = localStorage.getItem('news');
    if (savedNews) {
      const newsItems: NewsItem[] = JSON.parse(savedNews);
      if (newsItems.length > 0) {
        // 최신 뉴스 1개 가져오기
        setLatestNews(newsItems[0]);
      }
    }
  }, []);

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
  };

  return (
    <section className="relative min-h-[600px] flex items-center hero-pattern text-white overflow-hidden">
      {/* Background Image Overlay */}
      <div className="absolute inset-0 opacity-20">
        <img 
          src="https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" 
          alt="Modern office workspace" 
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Main Content */}
      <div className="w-full relative z-10 py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl">
            {/* Top Label */}
            <div className="flex items-center space-x-2 mb-6">
              <span className="h-1 w-12 bg-secondary block"></span>
              <span className="text-secondary font-bold tracking-widest uppercase text-sm">
                Total Education Solutions
              </span>
            </div>

            {/* Main Heading */}
            <h1 className="text-5xl md:text-7xl font-black leading-tight mb-8">
              콘텐츠의 가치를 높이는<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-teal-400">
                압도적 기술력과 경험
              </span>
            </h1>

            {/* Description */}
            <p className="text-xl text-gray-300 mb-10 font-light max-w-2xl">
              국내 300여 개 기관 파트너. 기획부터 시스템 구축까지 One-Stop 제공.
            </p>

            {/* CTA Button */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="#contact" 
                className="px-10 py-4 bg-secondary text-white font-bold text-lg hover:bg-blue-600 transition cursor-pointer text-center whitespace-nowrap inline-block"
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById('contact');
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                소개서 다운로드
              </a>
            </div>
          </div>
        </div>

        {/* Notice Bar */}
        <div className="absolute bottom-0 left-0 right-0 w-full bg-white/10 backdrop-blur-md border-t border-gray-700 h-16 flex items-center">
          <div className="container mx-auto px-6 flex items-center">
            <span className="text-secondary font-bold mr-6 text-sm whitespace-nowrap">NOTICE</span>
            {latestNews ? (
              <a
                onClick={() => handleNavigation('/news')}
                className="text-gray-300 text-sm truncate hover:text-white transition cursor-pointer"
              >
                {latestNews.title}
              </a>
            ) : (
              <span className="text-gray-300 text-sm truncate">
                등록된 공지사항이 없습니다
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}